import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        email,
        password
      });

      const { access_token, user, requires_password_change, message } = response.data;

      // Check if user is admin
      if (user.role !== 'admin') {
        setError('Access denied. Admin privileges required.');
        setLoading(false);
        return;
      }

      // Store token
      localStorage.setItem('admin_token', access_token);
      localStorage.setItem('admin_email', user.email);

      // If admin needs to change password (using default password)
      if (requires_password_change) {
        // Store flag to show password change modal on dashboard
        localStorage.setItem('force_password_change', 'true');
        localStorage.setItem('password_change_message', message || 'Please change your default password for security.');
      }

      // Redirect to admin dashboard
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#E8E4DF] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 
            className="text-4xl mb-2 text-gray-800"
            style={{ fontFamily: 'IBM Plex Serif, serif' }}
          >
            Admin Login
          </h1>
          <p 
            className="text-gray-600"
            style={{ fontFamily: 'IBM Plex Serif, serif' }}
          >
            Clarity Journal Management
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 p-3 bg-red-50 text-red-600 rounded text-sm">
                {error}
              </div>
            )}

            <div className="mb-4">
              <label 
                className="block text-gray-700 mb-2"
                style={{ fontFamily: 'IBM Plex Serif, serif' }}
              >
                Admin Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-gray-800"
                style={{ fontFamily: 'IBM Plex Serif, serif' }}
              />
            </div>

            <div className="mb-6">
              <label 
                className="block text-gray-700 mb-2"
                style={{ fontFamily: 'IBM Plex Serif, serif' }}
              >
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-gray-800"
                style={{ fontFamily: 'IBM Plex Serif, serif' }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gray-800 text-white py-3 rounded-full hover:bg-gray-700 transition-all disabled:opacity-50"
              style={{ fontFamily: 'IBM Plex Serif, serif' }}
            >
              {loading ? 'Logging in...' : 'Login to Dashboard'}
            </button>
          </form>

          <div className="mt-4 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-gray-600 hover:text-gray-800 text-sm"
              style={{ fontFamily: 'IBM Plex Serif, serif' }}
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
